import { useParams } from 'react-router-dom';
import { Show } from 'framework/show';
import useBillingService, { ApproveBillingData, BillingScheduleItemResult } from '../billingService';
import { ScheduleItem, ScheduleItemStatus } from '../billingTypes';
import ApproveBillingContent from './ApproveBillingContent';
import { useProjectFinanceService } from 'domain/shared/newProject';

const ApproveBillingLayout = () => {
  const { getBillingRequest } = useBillingService();
  const { budgetsSearch } = useProjectFinanceService();
  const { billingScheduleId, billingRequestId } = useParams<Dictionary<string>>();

  const getDataMethod = async () => {
    const billingRequest = await getBillingRequest(billingScheduleId!, billingRequestId!);
    const items: BillingScheduleItemResult[] = billingRequest.items.map(item => ({
      id: item.id,
      billingRequestId: billingRequest.id,
      milestoneName: item.name,
      amount: item.amount,
      currency: item.currency,
      hours: item.hours,
      plannedRegularHours: item.plannedRegularHours,
      plannedOvertimeHours: item.plannedOvertimeHours,
      previousPeriodAdjustmentHours: item.previousPeriodAdjustmentHours,
      position: '',
      type: ScheduleItem.MILESTONE,
      sowId: billingRequest.sowId,
      status: ScheduleItemStatus.SCHEDULE_ITEM_RELATED,
      invoiceDate: null,
      createdAt: item.createdAt,
      createdBy: item.createdBy,
      updatedAt: item.updatedAt,
      updatedBy: item.updatedBy,
    }));

    let relatedDocuments: string[] = [];
    let budgetId: number | undefined;

    try {
      const budgetsResponse = await budgetsSearch({
        pageNumber: 0,
        pageSize: 10,
        filter: {
          projectName: {
            eq: billingRequest.projectName,
          },
          sowId: {
            eq: billingRequest.sowId,
          },
        },
      });

      const budget = budgetsResponse?.result?.[0];
      const sowStructureItem = budget?.structure?.find(item => item.source === 'SOW' && item.status === 'APPROVED');
      relatedDocuments = sowStructureItem?.relatedDocuments || [];
      budgetId = budget?.id;
    } catch (error) {}

    const result: ApproveBillingData = {
      items,
      type: billingRequest.billingType,
      createdBy: billingRequest.createdBy,
      createdAt: billingRequest.createdAt,
      sowId: billingRequest.sowId,
      note: billingRequest.note,
      serviceDetailsArtifactId: billingRequest.serviceDetailsArtifactId,
      reimbursementDocumentationArtifactIds: billingRequest.reimbursementDocumentationArtifactIds,
      startDate: billingRequest.startDate,
      endDate: billingRequest.endDate,
      status: billingRequest.status,
      rejectionReason: billingRequest.rejectionReason,
      relatedDocuments,
      budgetId,
      project: {
        name: billingRequest.projectName,
        projectManager: billingRequest.projectManager,
        accountData: {
          accountId: billingRequest.accountId,
          sowId: Number(billingRequest.sowId),
        },
      },
    };

    return result;
  };

  return (
    <Show getDataMethod={getDataMethod}>
      <ApproveBillingContent refetch={getDataMethod} />
    </Show>
  );
};

export default ApproveBillingLayout;
